type BuildPairTransactionQueryArgs = {
  isAdvertiserAccount: boolean
  counterpartId?: string | null
  checkingAccountId?: string | null
  page: number
  quantity: number
  transactionType?: string | null
  startDate?: string
  endDate?: string
  userInfo?: boolean
}

export const buildPairTransactionQuery = ({
  isAdvertiserAccount,
  counterpartId,
  checkingAccountId,
  page,
  quantity,
  transactionType,
  startDate,
  endDate,
  userInfo
}: BuildPairTransactionQueryArgs) => ({
  page,
  quantity,
  ...(isAdvertiserAccount
    ? { publisher_id: counterpartId }
    : { advertiser_id: counterpartId }),
  ...(checkingAccountId ? { checking_account_id: checkingAccountId } : {}),
  ...(transactionType ? { transaction_type: transactionType } : {}),
  ...(startDate ? { start_date: startDate } : {}),
  ...(endDate ? { end_date: endDate } : {}),
  ...(userInfo ? { user_info: true } : {})
})
